import React from "react";
import { PDFViewer } from "@react-pdf/renderer";
import MemorialDocument, { MemorialDocumentProps } from "./MemorialDocument";

const MemorialPDFViewer: React.FC<MemorialDocumentProps> = ({
    memorial, businessLogo, videoPosters,
}) => (
    <PDFViewer style={{ width: "100%", height: "100vh" }} showToolbar={false}>
        <MemorialDocument
            memorial={memorial}
            businessLogo={businessLogo}
            videoPosters={videoPosters}
        />
    </PDFViewer>
);

export default MemorialPDFViewer;
